var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "base-agent-search-options" } },
    [
      _c("or-input", {
        attrs: {
          label: _vm.$t("hitl.modules.agent-picker.search-username-label"),
          "model-value": _vm.options.search || "",
          disabled: _vm.isDisabled,
        },
        on: {
          "update:modelValue": function ($event) {
            return _vm.onPropertyChange({ search: $event })
          },
        },
      }),
      _vm._v(" "),
      _c("or-select", {
        attrs: {
          label: _vm.$t("hitl.modules.agent-picker.search-status-label"),
          "model-value": _vm.options.status || [],
          options: _vm.statusOptions,
          multiple: true,
          disabled: _vm.isDisabled,
        },
        on: {
          "update:modelValue": function ($event) {
            return _vm.onPropertyChange({ status: $event })
          },
        },
      }),
      _vm._v(" "),
      _c("or-select", {
        attrs: {
          label: _vm.$t("hitl.modules.agent-picker.search-rule-groups-label"),
          "model-value": _vm.options.ruleGroupIds || [],
          options: _vm.ruleGroupsOptions,
          multiple: true,
          "enable-search": true,
          disabled: _vm.isDisabled,
        },
        on: {
          "update:modelValue": function ($event) {
            return _vm.onPropertyChange({ ruleGroupIds: $event })
          },
        },
      }),
      _vm._v(" "),
      _c("or-select", {
        attrs: {
          label: _vm.$t("hitl.modules.agent-picker.search-rule-tags-label"),
          "model-value": _vm.options.ruleTags || [],
          options: _vm.ruleTagsOptions,
          multiple: true,
          "enable-search": true,
          disabled: _vm.isDisabled,
        },
        on: {
          "update:modelValue": function ($event) {
            return _vm.onPropertyChange({ ruleTags: $event })
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }